<template>
  <div :class="['invoice-product-name-select', compact ? 'is-compact' : '']">
    <el-select
      :model-value="normalizedValue"
      multiple
      collapse-tags
      collapse-tags-tooltip
      :max-collapse-tags="compact ? 1 : 2"
      :placeholder="placeholderText"
      :disabled="disabled"
      :class="['w-full', compact ? 'invoice-product-name-select-control is-compact' : 'invoice-product-name-select-control']"
      @update:modelValue="updateValue"
    >
      <template #prefix>
        <span class="selected-summary">{{ selectedSummary }}</span>
      </template>
      <template #header>
        <div class="product-select-toolbar">
          <button type="button" class="select-all" @click.stop="selectAll">全选</button>
          <button type="button" class="select-all" @click.stop="clearToDefault">默认</button>
        </div>
      </template>
      <el-option
        v-for="name in ENTERPRISE_INVOICE_PRODUCT_NAMES"
        :key="name"
        :label="name"
        :value="name"
      >
        <div :class="['option-row', isSelected(name) ? 'is-selected' : '']">
          <span>{{ name }}</span>
          <span v-if="checkIconVisible(name)" class="option-check">已选</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES,
  ENTERPRISE_INVOICE_PRODUCT_NAMES,
  normalizeProductNames
} from '../productNames'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  label: { type: String, default: '品名' },
  placeholder: { type: String, default: '' },
  compact: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue'])

const normalizedValue = computed(() => normalizeProductNames(props.modelValue))
const selectedSummary = computed(() => `已选 ${normalizedValue.value.length} 项`)
const placeholderText = computed(() => props.placeholder || `请选择${props.label}`)

function updateValue(value) {
  emit('update:modelValue', normalizeProductNames(value))
}

function isSelected(name) {
  return normalizedValue.value.includes(name)
}

function checkIconVisible(name) {
  return isSelected(name)
}

function selectAll() {
  emit('update:modelValue', [...ENTERPRISE_INVOICE_PRODUCT_NAMES])
}

function clearToDefault() {
  emit('update:modelValue', [...DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES])
}
</script>

<style scoped>
.invoice-product-name-select :deep(.el-select__wrapper) {
  min-height: 38px;
  align-items: center;
}
.invoice-product-name-select.is-compact :deep(.el-select__wrapper) {
  min-height: 32px;
  font-size: 12px;
}
.invoice-product-name-select :deep(.el-select__prefix) {
  margin-right: 4px;
}
.selected-summary {
  display: inline-flex;
  align-items: center;
  height: 20px;
  border-radius: 999px;
  padding: 0 7px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.product-select-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding: 6px 8px;
  border-bottom: 1px solid #e2e8f0;
}
.select-all {
  border: 0;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}
.select-all:hover {
  color: #1d4ed8;
}
.option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}
.option-row.is-selected {
  color: #2563eb;
  font-weight: 600;
}
.option-check {
  flex: none;
  border-radius: 999px;
  padding: 1px 6px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
}
</style>
